import Chip from "components/common/Chip";
import React from "react";

type PROPS = {
  label?: string;
  status: number | null;
};

const SaleStatusChip: React.FC<PROPS> = (props) => {
  const label = props.label ?? "";
  const status = props.status;

  const getColor = (status: number | null) => {
    /** 販売ステータス (1：販売中, 2：販売停止, null：未登録) */
    switch (status) {
      case null:
        return "#fb545a";
      case 1:
        return "#4a88cb";
      case 2:
        return "#6c6c6c";
      default:
        return "";
    }
  };

  return <Chip text={label} width="5rem" color={getColor(status)} />;
};

export default SaleStatusChip;
